import type { FeatureFlags } from './feature-flags.types';

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  articles: false,
  webinars: true,
  downloads: true,
  guides: true,
  courses: true,
  releaseNotes: true,
  'tab-goals': false,
  'goals-monitoring': false,
  'critical-elements-monitoring': false,
  'tab-insights': false,
  'tab-fao': false,
  'ai-assistant': false,
  'ai-token-usage': false,
  'ai-mark-monitoring': false,
  'critical-populations': false,
};
